import { api } from '@/lib/api';
import type {
  IApiResponse,
  INordicReviewMetricResponse,
  INordicReviewTeamMember,
  NordicReviewClock,
} from '@skystone/shared';

export interface NordicReviewQueryParams {
  from: string;
  to: string;
  clock: NordicReviewClock;
  granularity: 'daily' | 'weekly' | 'monthly';
  /** Team name, not id — the roster is keyed by the plain string. */
  teamName?: string;
}

function buildQuery(params: NordicReviewQueryParams): string {
  const search = new URLSearchParams();
  search.set('from', params.from);
  search.set('to', params.to);
  search.set('clock', params.clock);
  search.set('granularity', params.granularity);
  if (params.teamName) search.set('teamName', params.teamName);
  return `?${search.toString()}`;
}

export const nordicReviewApi = {
  getFirstReview: async (
    params: NordicReviewQueryParams,
  ): Promise<INordicReviewMetricResponse> => {
    const result = await api.get<IApiResponse<INordicReviewMetricResponse>>(
      `/nordic-review/first-review${buildQuery(params)}`,
    );
    return result.data;
  },

  getMerge: async (params: NordicReviewQueryParams): Promise<INordicReviewMetricResponse> => {
    const result = await api.get<IApiResponse<INordicReviewMetricResponse>>(
      `/nordic-review/merge${buildQuery(params)}`,
    );
    return result.data;
  },

  getRoster: async (): Promise<INordicReviewTeamMember[]> => {
    const result = await api.get<IApiResponse<INordicReviewTeamMember[]>>('/nordic-review/roster');
    return result.data;
  },
};
